import { h } from 'preact';
import styles from './Pagination.module.scss';
export function Pagination({ meta, onChange }) {
    const { currentPage, totalPages } = meta;
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    return (h("div", { class: styles.pagination }, pages.map(page => (h("button", { key: page, class: `${styles.pageButton} ${page === currentPage ? styles.active : ''}`, onClick: () => onChange(page), disabled: page === currentPage }, page)))));
}
